export default __webpack_public_path__ + "static/media/hoasen_home_Logo_2.61086ca6.png";